export default {
  defaultProps: {
    colorScheme: 'primary',
  },
}
